import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <h3 className="text-2xl font-bold mb-6 font-sans text-brand-dark" data-id="element-35">
      Política de Privacidad
    </h3>
    <div className="space-y-4 text-stone-600 leading-relaxed text-sm" data-id="element-36">
      <p data-id="element-37">
        <strong data-id="element-38">Última actualización:</strong> Enero 2025
      </p>
      <p data-id="element-39">
        En Cena en 15, nos tomamos muy en serio la privacidad de nuestros
        usuarios. Esta política describe cómo recopilamos, usamos y protegemos
        tu información personal.
      </p>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-40">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-41">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital, incluyendo: nombre, dirección de
        correo electrónico e información de pago.
      </p>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-42">
        2. Uso de la Información
      </h4>
      <p data-id="element-43">Tu información se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-44">
        <li data-id="element-45">Procesar y entregar tu compra.</li>
        <li data-id="element-46">Enviarte actualizaciones relacionadas con el producto.</li>
        <li data-id="element-47">Brindarte soporte al cliente si lo necesitas.</li>
      </ul>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-48">
        3. Protección de Datos
      </h4>
      <p data-id="element-49">
        Utilizamos medidas de seguridad estándar de la industria para proteger
        tu información personal. No almacenamos datos de tarjetas de crédito en
        nuestros servidores.
      </p>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-50">
        4. Compartir Información
      </h4>
      <p data-id="element-51">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto a proveedores de servicios de confianza que nos ayudan
        a operar nuestro sitio web y procesar pagos.
      </p>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-52">5. Cookies</h4>
      <p data-id="element-53">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio.
      </p>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-54">
        6. Tus Derechos
      </h4>
      <p data-id="element-55">
        Tienes derecho a solicitar acceso, corrección o eliminación de tus datos
        personales en cualquier momento.
      </p>
    </div>
  </>;
const termsContent = <>
    <h3 className="text-2xl font-bold mb-6 font-sans text-brand-dark" data-id="element-56">
      Términos y Condiciones
    </h3>
    <div className="space-y-4 text-stone-600 leading-relaxed text-sm" data-id="element-57">
      <p data-id="element-58">
        <strong data-id="element-59">Última actualización:</strong> Enero 2025
      </p>
      <p data-id="element-60">
        Al adquirir y utilizar el producto digital "Cena en 15", aceptas los
        siguientes términos y condiciones.
      </p>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-61">
        1. Producto Digital
      </h4>
      <p data-id="element-62">
        "Cena en 15" es un producto digital descargable que incluye guías,
        recetarios y materiales de planificación de comidas. El acceso se otorga
        inmediatamente después de la compra.
      </p>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-63">
        2. Uso Personal
      </h4>
      <p data-id="element-64">
        El contenido adquirido es para uso personal y familiar únicamente. Queda
        prohibida la reproducción, distribución o reventa del material sin
        autorización expresa.
      </p>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-65">3. Pagos</h4>
      <p data-id="element-66">
        El precio del producto es un pago único de $6.35 USD. No hay cargos
        recurrentes ni suscripciones ocultas.
      </p>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-67">4. Resultados</h4>
      <p data-id="element-68">
        Los resultados mencionados (ahorro de dinero, tiempo, etc.) son
        estimaciones basadas en promedios y pueden variar según las
        circunstancias individuales de cada familia.
      </p>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-69">
        5. Propiedad Intelectual
      </h4>
      <p data-id="element-70">
        Todo el contenido de "Cena en 15", incluyendo textos, imágenes, diseños
        y metodologías, está protegido por derechos de autor.
      </p>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-71">
        6. Limitación de Responsabilidad
      </h4>
      <p data-id="element-72">
        Este producto ofrece información general sobre planificación de comidas
        y no constituye asesoramiento médico ni nutricional profesional.
        Consulta a un profesional de salud si tienes necesidades dietéticas
        específicas.
      </p>

      <h4 className="text-lg font-bold text-brand-dark pt-2" data-id="element-73">
        7. Modificaciones
      </h4>
      <p data-id="element-74">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones serán efectivas una vez publicadas en esta
        página.
      </p>
    </div>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 bg-brand-dark text-stone-500 border-t border-stone-800" data-id="element-75">
        <div className="max-w-4xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-76">
          <p className="font-sans text-sm" data-id="element-77">
            Cena en 15 &copy; {new Date().getFullYear()}
          </p>
          <div className="flex items-center gap-6 text-sm" data-id="element-78">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-stone-300 transition-colors underline underline-offset-2" data-id="element-79">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-stone-300 transition-colors underline underline-offset-2" data-id="element-80">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-81">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-82">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-83">
              <div className="flex items-center justify-end p-4 pb-0" data-id="element-84">
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-stone-100 transition-colors text-stone-400 hover:text-stone-700" data-id="element-85">
                  <XIcon className="w-5 h-5" data-id="element-86" />
                </button>
              </div>
              <div className="px-8 pb-8 overflow-y-auto" data-id="element-87">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}